export default __webpack_public_path__ + "static/media/TopBarExit.a06dce08.svg";